import { render } from "./FacultyLoadDialog.vue?vue&type=template&id=680f4abf"
import script from "./FacultyLoadDialog.vue?vue&type=script&lang=js"
export * from "./FacultyLoadDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__